/* 채널톡 관련 개발 @ahn */
/* https://developers.channel.io/reference/welcome-to-channel-kr */

import { components } from '../constants/schema'
import * as ChannelService from '@channel.io/channel-web-sdk-loader'

export type ChIdentification = {
  danalName?: string
  danalPhoneNumber?: string
}

export type ChProduct = {
  id?: components['schemas']['ProductDto']['id']
  name?: components['schemas']['ProductDto']['name']
  artist?: components['schemas']['ProductDto']['artist']
}

export type ChUserProduct = {
  id?: components['schemas']['UserProductDto']['id']
  subscriptionShares?: components['schemas']['UserProductDto']['subscriptionShares']
  balance?: components['schemas']['UserProductDto']['balance']
  createdDate?: components['schemas']['UserProductDto']['createdDate']
}

/** ChannelIO: '청약 신청하기' 버튼을 클릭하고 매각 위탁에 대한 동의/투자계약서를 동의한 시점 */
export const chSuccessSubscriptionProduct = (
  identification?: ChIdentification,
  product?: ChProduct,
  userProduct?: ChUserProduct,
) => {
  const name = identification?.danalName ?? ''
  const productName = product?.name ?? ''
  const productArtist = product?.artist ?? ''

  let now = new Date()
  if (userProduct?.createdDate) now = new Date(userProduct?.createdDate)
  const createdDate = `${now.getFullYear()}년 ${now.getMonth() + 1}월 ${now.getDate()}일`

  const count = userProduct?.subscriptionShares ?? 0
  const amount = userProduct?.balance ?? 0
  const orderSequence = userProduct?.id ? String(userProduct?.id).padStart(8, '0') : ''

  const trackObj = { name, productName, productArtist, createdDate, count, amount, orderSequence }
  ChannelService.track('success_subscription_product', trackObj)

  ChannelService.addTags(['청약신청/2차'])

  return
}

/** ChannelIO: 자산상세 페이지에서 청약취소 버튼 클릭하여 '네' 버튼을 클릭한 시점 */
export const chCancelSubscriptionProduct = (
  identification?: ChIdentification,
  product?: ChProduct,
  userProduct?: ChUserProduct,
) => {
  const name = identification?.danalName ?? ''
  const productName = product?.name ?? ''
  const productArtist = product?.artist ?? ''

  const now = new Date()
  const createdDate = `${now.getFullYear()}년 ${now.getMonth() + 1}월 ${now.getDate()}일`

  const count = userProduct?.subscriptionShares ?? 0
  const amount = userProduct?.balance ?? 0
  const orderSequence = userProduct?.id ? String(userProduct?.id).padStart(8, '0') : ''

  const trackObj = { name, productName, productArtist, createdDate, count, amount, orderSequence }
  ChannelService.track('cancel_subscription_product', trackObj)

  ChannelService.removeTags(['청약신청/2차'])

  return
}
